import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { deleteEmployees } from "../../infrastructure/repository/employees-repository";
import { findFreshEmployees } from "../../infrastructure/employees-cache";
import { hideModal } from "../commons/hide-modal";
import { displayActionConfirmationModal } from "../display-action-confirmation-modal";
import { displayEmployeesPage } from "./displays/display-employees-page";
import { translate as t } from "../../infrastructure/translate/localization";

import { Routes } from "../../app/routes/config";

export default async function deleteMultipleEmployees(payload) {
  await hideModal();

  displayActionConfirmationModal({
    message: t(
      "employees-section.delete-multiple-active-employees-modal-title",
      { numEmployees: payload.operations.length }
    ),
    cantBeReverted: true,
    actionName: t("employees-section.delete-employees"),
    callback: async () => {
      displayActionConfirmationModal({
        message: t("employees-section.deleting-employees-warning"),
        actionName: t("employees-section.delete-employees"),
        callBackIsLoading: true,
        disableClose: true,
      });
      const companyId = await findCompanyId();
      await deleteEmployees({ payload, companyId });
      await findFreshEmployees({ companyId });
      await hideModal();
      if (window.location.search !== "") {
        window.location.replace(`${Routes.EMPLOYEES_V2_WITH_PARAMS}`);
      } else {
        await displayEmployeesPage();
      }
    },
  });
}
